import React from 'react';

import {Settings} from '@mui/icons-material';
import List from 'components/list/List';
import {CheckField, ListField} from 'components/list/Fields';
import ActionMenuItemEdit from 'components/list/actionMenu/ActionMenuItemEdit';
import ActionMenu from 'components/list/actionMenu/ActionMenu';
import ConfigurationForm from './ConfigurationForm';
import {Stack} from '@mui/material';
import ClearCacheButton from './ClearCacheButton';
import PullCorosActivitiesButton from './PullCorosActivitiesButton';

const ConfigurationsPage = () => {
  return (
    <React.Fragment>
      <List
        avatar={<Settings />}
        title="Configurations"
        bulkOptions={false}
        hidePagination
        toolbar={
          <Stack direction="row" alignItems="right" justifyContent="flex-end" gap={2}>
            <PullCorosActivitiesButton />
            <ClearCacheButton />
          </Stack>
        }
      >
        <ListField source="name" label="Name" />
        <ListField source="value" label="Value" />
        <CheckField source="isVisible" label="Visible" />
        <CheckField source="isEditable" label="Editable" />
        <ActionMenu label="Actions" align="right" width="5%">
          <ActionMenuItemEdit confirmContent={<ConfigurationForm />} />
        </ActionMenu>
      </List>
    </React.Fragment>
  );
};

export default ConfigurationsPage;
